import React from 'react';
import { FooterButton, FooterButtonProps } from './FooterButton';
import { FooterTip, FooterTipProps } from './FooterTip';
import { EmptyDiv, FooterContainer } from './Footer.styled';

export interface FooterProps {
  nextButton?: FooterButtonProps;
  backButton?: FooterButtonProps;
  tipProps?: FooterTipProps;
  options?: {
    removeUndefinedElements: boolean;
  }
}

export const Footer = ({
  nextButton,
  backButton,
  tipProps,
  options = {removeUndefinedElements: false}
}: FooterProps) => {
  return (
    <FooterContainer centerFlex={options.removeUndefinedElements}>
      {backButton ? <FooterButton {...backButton}/> : (!options.removeUndefinedElements && <EmptyDiv/>)}
      {tipProps ? <FooterTip {...tipProps}/> : (!options.removeUndefinedElements && <EmptyDiv/>)}
      {nextButton ? <FooterButton {...nextButton}/> : (!options.removeUndefinedElements && <EmptyDiv/>)}
    </FooterContainer>
  );
};
